
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categoria/[categoria]",
      function () {
        return require("private-next-pages/categoria/[categoria].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categoria/[categoria]"])
      });
    }
  